import React from "react";
// ANT DESIGN COMPONENTS
import { Button } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import {
	updateOpenFormOffsetType,
	updateOffsetTypeRefreshTable,
	updateOpenFormOffsetTypeAction,
	updateShowOffsetTypeForm,
} from "../../../redux/tools/toolsSlice";
// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
// INTERFACES
import { RootState } from "../../../app/store";

function OffsetTypeHeader() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const dispatch = useDispatch();
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { permissions } = useSelector((state: RootState) => state.user);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const handleOpenModalCreateNewOffsetType = () => {
		dispatch(updateOpenFormOffsetType(true));
		dispatch(updateOpenFormOffsetTypeAction("create"));
	};

	const handleReloadPage = () => {
		dispatch(updateOffsetTypeRefreshTable(true));
		setTimeout(() => {
			dispatch(updateOffsetTypeRefreshTable(false));
		}, 1000);
	};

	return (
		<div className='generalStyles__pageHeader'>
			<div className='generalStyles__mlFix mt-1'>
				<Button
					onClick={() => {
						dispatch(updateShowOffsetTypeForm(false));
					}}
				>
					{t("configuration.cancel")}
				</Button>
			</div>
			{validatePermission("offset-types-catalog", permissions) && (
				<div className='generalStyles__mlFix mt-1'>
					<Button
						type='primary'
						icon={<FontAwesomeIcon icon={faPlus} className='generalStyles__mrFix' />}
						onClick={handleOpenModalCreateNewOffsetType}
					>
						{t("configuration.configurationFiles.createNewOffsetType")}
					</Button>
				</div>
			)}
			{validatePermission("offset-types-catalog", permissions) && (
				<div className='generalStyles__mlFix mt-1'>
					<Button
						type='primary'
						icon={<FontAwesomeIcon icon={faArrowsRotate} className='generalStyles__mrFix' />}
						onClick={() => {
							handleReloadPage();
						}}
					>
						{t("edgeManagement.banks.refreshTable")}
					</Button>
				</div>
			)}
		</div>
	);
}

export default OffsetTypeHeader;
